/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChangeLogModel } from '../../models/change-log-model';

export interface GetChangeLog$Params {
  entityID?: number;
  entityTypeID?: number;
}

export function GetChangeLog(http: HttpClient, rootUrl: string, params?: GetChangeLog$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ChangeLogModel>>> {
  const rb = new RequestBuilder(rootUrl, GetChangeLog.PATH, 'get');
  if (params) {
    rb.query('entityID', params.entityID, {});
    rb.query('entityTypeID', params.entityTypeID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ChangeLogModel>>;
    })
  );
}

GetChangeLog.PATH = '/api/Supervisor/GetChangeLog';
